import React from "react";
import PropTypes from 'prop-types';
import CONST from "../../config/CONST";
import RadioButton from "../RadioButton/RadioButton";

const FinancialProductSelection = (props) => {

    const {
        product,
        value,
        onChange,
        checked
    } = props;

    return (
        <>
            <div className={`${CONST.CSS_NAMESPACE}FinancialProductSelection`}>
                <RadioButton
                    onCheck={(clicked) => onChange(product.productTypeCode, clicked)}
                    defaultChecked={checked}
                    value={value}
                    product={product}
                />
            </div>
        </>
    )
}

FinancialProductSelection.propTypes = {
    product: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired
}

export default FinancialProductSelection;